import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

export const SvgContainer = styled.svg`
  height: ${({ itemHeight }) => itemHeight};
  width: ${({ itemWidth }) => itemWidth};
`;

export default class SVGElement extends Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
  };

  static defaultProps = {
    height: 'auto',
    width: 'auto',
  };

  render() {
    const {
      children,
      className,
      height,
      viewBox,
      width,
      preserveAspectRatio,
    } = this.props;

    return (
      <SvgContainer
        className={className}
        itemHeight={height}
        itemWidth={width}
        xmlns="http://www.w3.org/2000/svg"
        viewBox={viewBox}
        preserveAspectRatio={preserveAspectRatio}
      >
        {children}
      </SvgContainer>
    );
  }
}
